<div class="ribbon">
	<div class="ribbon-content">
		<img [src]="'/assets/images/verify-now.svg'" [alt]="'verify_alt_text' | translate" />
		<div class="ribbon-content-text">
			<span class="button-weight">{{ "kyc_up_to_date_question" | translate }}</span>
			<span>{{ "kyc_keep_personal_info_up_to_date" | translate }}</span>
		</div>
	</div>
	<a class="btn ribbon-button" (click)="onReviewClick()">{{ "kyc_review_now" | translate }}</a>
</div>
